import type * as React from "react";

const SIZES = { sm: 28, default: 40, lg: 48 } as const;

export type AvatarProps = React.HTMLAttributes<HTMLSpanElement> & {
  src?: string;
  alt?: string;
  fallback?: React.ReactNode;
  size?: keyof typeof SIZES;
  muted?: boolean;
};

/** Circular avatar: image if `src`, else `fallback` initials on a pink chip. */
export function Avatar({
  src,
  alt = "",
  fallback,
  size = "default",
  muted = false,
  className = "",
  style,
  ...props
}: AvatarProps) {
  const px = SIZES[size];
  return (
    <span
      className={["pr-avatar", muted ? "pr-avatar--muted" : "", className]
        .filter(Boolean)
        .join(" ")}
      style={{ width: px, height: px, fontSize: px * 0.4, ...style }}
      {...props}
    >
      {src ? <img src={src} alt={alt} /> : fallback}
    </span>
  );
}
